import React from "react"
import { Container, Row, Col, Button } from "react-bootstrap"

import Layout from "../components/layout"
import SEO from "../components/seo"
import GrowthEstimationImpact from "../components/growthEstimationImpact"
import EmailCapture from "../components/emailCapture"

import { config } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"
config.autoAddCss = false

const IndexPage = () => (
  <Layout>
    <SEO
      title="Growth estimation"
      keywords={[`growth estimation`, `arpa`, `trials`]}
    />
    <Container>
      <GrowthEstimationImpact />
      <EmailCapture />
      <Row className="justify-content-md-center">
        <Col sm="7" className="text-center mt-5">
          <h2>Calculate SaaS metrics directly from Google Sheets</h2>
          <p className="mt-4">
            <Button
              variant="primary"
              href="https://workspace.google.com/marketplace/app/probe/1085080411800"
            >
              Install Plugin from Google Marketplace
            </Button>
          </p>
        </Col>
      </Row>
    </Container>
  </Layout>
)

export default IndexPage
